import type { FormEvent } from "react";

import { ResetPasswordPage } from "@repo/ui";
import { useContext, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";

import { AccountController } from "../../api/accountController";
import { AuthContext } from "./context";
import { useAuthSettings } from "./hooks";

export function TLPCloudResetPasswordPage() {
	const { username } = useContext(AuthContext);
	const [password, setPassword] = useState<string>("");
	const [disabled, setDisabled] = useState<boolean>(false);
	const [error, setError] = useState<string>("");
	const [loggingIn, setLoggingIn] = useState<boolean>(false);
	const history = useHistory();
	const authSettingsQuery = useAuthSettings();

	useEffect(() => {
		document.title = "TLP Cloud - Reset Password";
	}, []);

	async function submit(event: FormEvent<HTMLFormElement>) {
		event.preventDefault();
		if (!password) return;
		setDisabled(true);
		setLoggingIn(true);
		await login();
		setDisabled(false);
		setLoggingIn(false);
	}

	async function login() {
		const response = await AccountController.resetPassword(username, password);

		if (!response.success) {
			setError(response.message ?? "Invalid username or password");
			return;
		}

		window.location.replace("/");
	}

	return (
		<ResetPasswordPage
			password={password}
			setPassword={setPassword}
			submitFunction={submit}
			disabled={disabled}
			loading={loggingIn}
			error={error}
			goBack={() => history.goBack()}
			backgroundImage={authSettingsQuery.data?.backgroundImage}
			appLogo={authSettingsQuery.data?.companyLogo}
		/>
	);
}
